import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router"
import { useDispatch, useSelector } from "react-redux"
import { AppDispatch, RootState } from "@/redux"
import { CredentialsAppHeader } from "../CredentialsAppHeader/CredentialsAppHeader"
import { LoginMethod } from "@/types/credentials"
import { appActions } from "@/redux/slice/appSlice"
import { getRespectiveForm } from '../helpers/getRespectiveForm'
import { CredentialMethod } from "@/constants/credentials/credential"
import { UserRole } from "@/constants/users/userRole"
import { App } from "@/types/applications"
import { ApplicationsAPI } from "@/API/Applications"
import { AppName } from "@/constants/application/application"

export const CredentialsCreate = () => {
  const navigate = useNavigate()
  const { appId } = useParams();
  const dispatch: AppDispatch = useDispatch()
  const { token, userData } = useSelector((state: RootState) => state.user)
  const { applications } = useSelector((state: RootState) => state.application)
  const [selectedApp, setSelectedApp] = useState<App | undefined>(undefined)
  const [loginMethods, setLoginMethods] = useState<LoginMethod[]>([])

  useEffect(() => {
    if (userData?.role === UserRole.USER) {
      return navigate('/credentials')
    }
    if (applications.length) {
      const app = applications.find(app => app.id === appId)
      if (app) {
        setSelectedApp(app)
      } else {
        navigate('/credentials')
      }
    }
  }, [applications, navigate, userData, appId])

  useEffect(() => {
    if (token && selectedApp) {
      dispatch(appActions.setLoading(true))
      const fetchAppLoginMethods = async () => {
        const resp = await ApplicationsAPI.getLoginMethodsOfApp(
          token,
          selectedApp.id
        )
        if (resp.data) {
          setLoginMethods(resp.data.loginMethods)
        }
      }
      fetchAppLoginMethods()
        .then(() => {
          dispatch(appActions.setLoading(false))
        })
        .catch(() => {
          dispatch(appActions.setLoading(false))
        })
    }
  }, [token, selectedApp, dispatch])

  return (
    <div className="protectedPageLayout">
      {selectedApp && (
        <>
          <CredentialsAppHeader
            method='Add'
            appName={selectedApp.displayName}
            iconUrl={selectedApp.logo}
          />
          {getRespectiveForm(
            selectedApp.name as AppName,
            selectedApp.id,
            loginMethods,
            CredentialMethod.CREATE,
            false
          )}
        </>
      )}
    </div>
  )
}
